/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Plan_FreeInputs */

const en_settings_overview_plan_free = /** @type {(inputs: Settings_Overview_Plan_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay as you go`)
};

/**
* | output |
* | --- |
* | "Pay as you go" |
*
* @param {Settings_Overview_Plan_FreeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_overview_plan_free = /** @type {((inputs?: Settings_Overview_Plan_FreeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Plan_FreeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_overview_plan_free(inputs)
});
export { settings_overview_plan_free as "settings.overview.plan_free" }